var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 25,
    viewBox: "0 0 37 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.069,
    y1: 0.065,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e142c0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 37,
    height: 25,
    transform: "translate(2.51 -0.076)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-2.51 0.076)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M8.754,12.716a1.721,1.721,0,0,0-.5-.327,1.518,1.518,0,0,0-1.669.327,1.373,1.373,0,0,0-.327.5,1.518,1.518,0,0,0,.327,1.669,1.721,1.721,0,0,0,.5.327,1.539,1.539,0,0,0,2-2,1.373,1.373,0,0,0-.327-.5m3.963-3.963A1.53,1.53,0,0,0,13.8,9.2a1.337,1.337,0,0,0,.583-.121,1.721,1.721,0,0,0,.5-.327,1.721,1.721,0,0,0,.327-.5,1.462,1.462,0,0,0,0-1.166,1.721,1.721,0,0,0-.327-.5,1.521,1.521,0,0,0-2.172,0,1.721,1.721,0,0,0-.327.5,1.462,1.462,0,0,0,0,1.166,1.721,1.721,0,0,0,.327.5M8.754,6.582A1.532,1.532,0,0,0,6.134,7.668a1.58,1.58,0,0,0,.121.583,1.721,1.721,0,0,0,.327.5A1.53,1.53,0,0,0,7.668,9.2a1.337,1.337,0,0,0,.583-.121,1.721,1.721,0,0,0,.5-.327,1.721,1.721,0,0,0,.327-.5,1.462,1.462,0,0,0,0-1.166,1.721,1.721,0,0,0-.327-.5m18.4,0a1.532,1.532,0,0,0-2.619,1.086,1.337,1.337,0,0,0,.121.583,1.721,1.721,0,0,0,.327.5,1.521,1.521,0,0,0,2.172,0,1.721,1.721,0,0,0,.327-.5,1.337,1.337,0,0,0,.121-.583,1.58,1.58,0,0,0-.121-.583,1.721,1.721,0,0,0-.327-.5m-7.22,5.686H13.8a1.534,1.534,0,1,0,0,3.067h6.134a1.534,1.534,0,0,0,0-3.067M29.138,0H4.6A4.6,4.6,0,0,0,0,4.6V16.869a4.6,4.6,0,0,0,4.6,4.6H29.138a4.6,4.6,0,0,0,4.6-4.6V4.6a4.6,4.6,0,0,0-4.6-4.6m1.534,16.869A1.534,1.534,0,0,1,29.138,18.4H4.6a1.534,1.534,0,0,1-1.534-1.534V4.6A1.534,1.534,0,0,1,4.6,3.067H29.138A1.534,1.534,0,0,1,30.672,4.6Zm-3.515-4.153a1.373,1.373,0,0,0-.5-.327,1.413,1.413,0,0,0-1.166,0,1.721,1.721,0,0,0-.5.327,1.6,1.6,0,0,0-.448,1.086,1.536,1.536,0,0,0,2.619,1.1,1.548,1.548,0,0,0,.327-1.685,1.373,1.373,0,0,0-.327-.5m-7.8-6.461a1.721,1.721,0,0,0-.5.327A1.6,1.6,0,0,0,18.4,7.668a1.58,1.58,0,0,0,.121.583,1.721,1.721,0,0,0,.327.5,1.53,1.53,0,0,0,1.086.448,1.337,1.337,0,0,0,.583-.121,1.721,1.721,0,0,0,.5-.327,1.721,1.721,0,0,0,.327-.5,1.337,1.337,0,0,0,.121-.583,1.6,1.6,0,0,0-.448-1.086,1.518,1.518,0,0,0-1.669-.327",
    transform: "translate(4.193 1.502)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardIcon);
export default __webpack_public_path__ + "static/media/keyboard-icon.6db95066222c0584cb4c915e0d15e037.svg";
export { ForwardRef as ReactComponent };